module.exports = __webpack_public_path__ + "img/sp.cf6a87b6.jpg";